import { ApolloClient } from '@apollo/client';
import { GET_USER_PRESENCE_QUERY } from 'src/graphql/entities/user-presence/user-presence.operations';
import { isStalePresence, usePresenceStore } from 'src/store/user-presence-store';
import { UserPresence } from './user-presence';

const QUEUE = new Set<string>();

let scheduled = false;

function scheduleFlush(client: ApolloClient<unknown>) {
  if (scheduled) return;
  scheduled = true;
  setTimeout(() => flush(client), 0);
}

async function flush(client: ApolloClient<unknown>) {
  scheduled = false;
  const ids = Array.from(QUEUE);
  QUEUE.clear();

  const { byId, inFlight, markInFlight, upsertMany } = usePresenceStore.getState();

  const toFetch = ids.filter((id) => !inFlight[id]).filter((id) => isStalePresence(byId[id]));

  if (!toFetch.length) return;

  markInFlight(toFetch, true);
  try {
    const { data } = await client.query<
      {
        getUserPresence: {
          items: UserPresence[];
        };
      },
      { params: { userIds: string[] } }
    >({
      query: GET_USER_PRESENCE_QUERY,
      variables: { params: { userIds: toFetch } },
      fetchPolicy: 'network-only',
      context: { ttl: 0 },
    });

    const items = data.getUserPresence.items.map((i) => ({
      ...i,
      updatedAt: Date.now(),
    }));
    upsertMany(items);
  } finally {
    usePresenceStore.getState().markInFlight(toFetch, false);
  }
}

export function requestPresence(ids: string[], client: ApolloClient<unknown>) {
  for (const id of ids) QUEUE.add(id);
  scheduleFlush(client);
}
